/**
 * StructuredAssessmentView — Parsed Feedback view for runs whose prompt
 * declares `outputSchemaType: 'StructuredAssessmentV1'` (STRUCTURED
 * multi-part questions). Admin-debug wrapper around the canonical
 * `StructuredAnalysis` schema view (per-part assessments + marks-weighted
 * partResults), mirroring `FreeformRubricView`'s composition. Adds the
 * admin-only cross-check block (student answer, correct answer, confidence).
 */
import type { Feedback } from '@padcanvas/shared';
import { StructuredAnalysis } from '../solution-analysis';
import { AdminCrossCheckFields, type SolutionLearningMoment, type RejectMomentHandler } from './AdminCrossCheckFields';

interface Props {
    feedback: Feedback;
    question?: { correctAnswer?: string };
    learningMoments?: SolutionLearningMoment[];
    onRejectMoment?: RejectMomentHandler;
}

export function StructuredAssessmentView({ feedback, question, learningMoments, onRejectMoment }: Props) {
    return (
        <div className="feedback-content">
            <StructuredAnalysis feedback={feedback} />
            <AdminCrossCheckFields feedback={feedback} question={question} learningMoments={learningMoments} onRejectMoment={onRejectMoment} />
        </div>
    );
}
